import { adminAPIService } from './index'

const route = 'posts'

export default {
  getList(page = 1, size = 50) {
    const params = { page, size }
    return adminAPIService({
      url: route,
      method: 'get',
      params,
    })
  },
}
